'use strict';

var cov_2r3dmfahat = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/html/menuBtn/menuBtn.js',
        hash = '35f2b7a3d6f6983e89f2bdd7921b5c9ef807746f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/html/menuBtn/menuBtn.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 37
                }
            },
            '1': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 39
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 40
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 42
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 33
                    },
                    end: {
                        line: 6,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 39
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 4
                    },
                    end: {
                        line: 11,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 15
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 15
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MenuBtnController = function () {
    function MenuBtnController($mdSidenav, $transitions) {
        var _this = this;

        _classCallCheck(this, MenuBtnController);

        cov_2r3dmfahat.f[0]++;
        cov_2r3dmfahat.s[0]++;

        this.$mdSidenav = $mdSidenav;

        cov_2r3dmfahat.s[1]++;
        $transitions.onStart({}, function () {
            cov_2r3dmfahat.f[1]++;
            cov_2r3dmfahat.s[2]++;

            _this.closeMenu();
        });
    }

    _createClass(MenuBtnController, [{
        key: 'openMenu',
        value: function openMenu() {
            cov_2r3dmfahat.f[2]++;
            cov_2r3dmfahat.s[3]++;

            this.$mdSidenav('menu').open();
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            cov_2r3dmfahat.f[3]++;
            cov_2r3dmfahat.s[4]++;

            this.$mdSidenav('menu').close();
        }
    }]);

    return MenuBtnController;
}();

cov_2r3dmfahat.s[5]++;


angular.module('app').component('menuBtn', {
    templateUrl: 'app/shared/html/menuBtn/menuBtn.html',
    controller: MenuBtnController
});